exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* .mainAndSideList{\n  display:flex;\n  flex-direction:row;\n} */\n\n.style__linkStyle__33nyX {\n  color: #000;\n}\n\n.style__linkStyle__33nyX:hover {\n  text-decoration: none;\n  color: #000;\n}\n.style__colNoPadding__3MOYX {\n  padding: 0;\n}\n.style__titleStyle__1_QNd {\n  font-weight: bold;\n  padding: 30px 0 10px 0;\n}\n\n.style__lineStyle__1FIOk {\n  margin-top: 35px;\n}\n", ""]);

// exports
exports.locals = {
	"linkStyle": "style__linkStyle__33nyX",
	"colNoPadding": "style__colNoPadding__3MOYX",
	"titleStyle": "style__titleStyle__1_QNd",
	"lineStyle": "style__lineStyle__1FIOk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/style.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/style.css
// module chunks = 0